import { Box } from "@mui/system";
import { SxProps } from "@mui/material";

export interface UIIconButtonProps {
    padding?: string;
    paddingLeft?: string;
    paddingRight?: string;
    paddingTop?: string;
    paddingBottom?: string;
    icon: JSX.Element;
    onClick: () => void;
    tooltip?: string;
    sx?: SxProps;
}

export function UIIconButton(props: UIIconButtonProps) {
    return (
        <Box
            sx={props.sx}
            padding={props.padding}
            paddingTop={props.paddingTop}
            paddingRight={props.paddingRight}
            paddingBottom={props.paddingBottom}
            paddingLeft={props.paddingLeft}
            onClick={props.onClick}
        >
            {props.icon}
        </Box>
    );
}
